import { render, staticRenderFns } from "./ningbo.vue?vue&type=template&id=49dafad2&scoped=true&"
import script from "./ningbo.vue?vue&type=script&lang=js&"
export * from "./ningbo.vue?vue&type=script&lang=js&"
import style0 from "./ningbo.vue?vue&type=style&index=0&id=49dafad2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dafad2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentType1: require('D:/Project/kpwebsite/PC/components/content/content-type-1.vue').default})
